import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-react';
import './LoggedUser.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tudoAzulNumber: PropTypes.string.isRequired,
  points: PropTypes.string.isRequired
};

class LoggedUser extends React.Component {
  getPointsFormatted(value) {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return value.replace(pattern, '.');
  }

  render() {
    return (
      <div id={this.props.id} className="LoggedUser">
        <div className="LoggedUser__informations">
          <div>
            <p className="LoggedUser__name">
              {I18n.translate('components.loggedUser.name-points-part1', { name: this.props.name })}
            </p>
            <span className="LoggedUser__pts">
              {I18n.translate('components.loggedUser.name-points-part2', {
                points: this.getPointsFormatted(this.props.points)
              })}
            </span>
          </div>
          <div className="LoggedUser__number">
            <span className="LoggedUser__number__text-style-1">
              {I18n.translate('components.loggedUser.number-part1')}
            </span>
            <span className="LoggedUser__number__text-style-2__desktop">
              {I18n.translate('components.loggedUser.number-part2.desktop')}
            </span>
            <span className="LoggedUser__number__text-style-3__desktop">
              {I18n.translate('components.loggedUser.number-part3.desktop')}
            </span>
            <span className="LoggedUser__number__text-style-2__mobile">
              {I18n.translate('components.loggedUser.number-part2.mobile')}
            </span>
            <span className="LoggedUser__number__text-style-3__mobile">
              {I18n.translate('components.loggedUser.number-part3.mobile')}
            </span>
            <span>
              {I18n.translate('components.loggedUser.number-part4', {
                number: this.props.tudoAzulNumber
              })}
            </span>
          </div>
        </div>        
      </div>
    );
  }
}

LoggedUser.propTypes = propTypes;

export default LoggedUser;



// WEBPACK FOOTER //
// ./src/components/loggedUser/LoggedUser.jsx